/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_0c588c4a","_0c588c4a",""]'><div :class='["","_0c588c4a",""]'><div :class='["picker-demo-title","_0c588c4a",""]'>basic-cascade-picker:</div><cube-cascade-picker ref="__mpx_ref_picker__" :list="(dataList)" :selectedIndex="(selectedIndex)" @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @change='(e)=>__invoke(e, [["onChange"]])' :class='["","_0c588c4a",""]'/><div :class='["button-wrapper","_0c588c4a",""]'><cube-button @_click="getSelected" :class='["","_0c588c4a",""]'>获取当前选中项</cube-button></div><div :class='["demo-data","_0c588c4a",""]' v-if="(selectedInfo.length || changeParams.length)"><template v-if="(selectedInfo.length)"><div :class='["key","_0c588c4a",""]'>getSelectedInfo 事件返回值：</div><div :class='["value","_0c588c4a",""]'><div v-for="(item, index) in (selectedInfo)" :key="item.index" :class='["value-item","_0c588c4a",""]'><div :class='["item-key","_0c588c4a",""]'>{{item[0]}}</div><div :class='["item-value","_0c588c4a",""]'>{{item[1]}}</div></div></div></template><template v-if="(changeParams.length)"><div :class='["key","_0c588c4a",""]'>change 事件参数：</div><div :class='["value","_0c588c4a",""]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item","_0c588c4a",""]'><div :class='["item-key","_0c588c4a",""]'>{{item[0]}}</div><div :class='["item-value","_0c588c4a",""]'>{{item[1]}}</div></div></div></template><template v-if="(changeParams.length)"><div :class='["key","_0c588c4a",""]'>columnChange 事件参数：</div><div :class='["value","_0c588c4a",""]'><div v-for="(item, index) in (columnChangeParams)" :key="item.index" :class='["","_0c588c4a",""]'><div :class='["value-number","_0c588c4a",""]'>第{{ index+1 }}次：</div><div v-for="(itemChild, itemIndex) in (item)" :key="itemChild.itemIndex" :class='["value-item","_0c588c4a",""]'><div :class='["item-key","_0c588c4a",""]'>{{itemChild[0]}}</div><div :class='["item-value","_0c588c4a",""]'>{{itemChild[1]}}</div></div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_0c588c4a"}'>
.picker-demo-title
  margin-bottom: 8px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
.button-wrapper
  margin-top: 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_0c588c4a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_0c588c4a"}
  /** script content **/
  require("./cascade-picker-basic.mpx.js?isComponent&outputPath=components%2Fcascade-picker-basic0c588c4a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./cascade-picker-basic.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcascade-picker-basic0c588c4a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_0c588c4a"],
    ctorType: "component",
    outputPath: "components/cascade-picker-basic0c588c4a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-cascade-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/cascade-picker/index.mpx?isComponent&outputPath=components%2Findexb6a89be4%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>